'use strict';

import React, { useCallback } from 'react'

import { PiFolderOpenThin } from 'react-icons/pi'

import bemit from '@function/bemit'

import { formatNum, num } from '@root/utility'

const { app } = window;

const dashboard_link = '/gestion-des-commandes/codes-promo';

export default function GroupedDiscountCodeRow ({ data, fields, ...props })
{
	const available = num(num(data.total, 0) - num(data.used_count, 0), 0);

	const requestDetails = useCallback(function (e)
	{
		e.preventDefault();

		window.localStorage.setItem('DiscountCodesList.searched', data._id || data.id);
		window.localStorage.removeItem('DiscountCodesList.used');

		try
		{
			app.router_history.push(dashboard_link);
		}
		catch (e)
		{
			window.location.pathname = dashboard_link;
		}
	},
	[data.id, data._id]);

	return (
		<div className="c-dashboard__row">

			<div className="c-dashboard__cell DiscountCodeByRef-product_name">

				<div className="c-dashboard__long-text">
					{ data._product?.name }
				</div>

			</div>

			<div className="c-dashboard__cell DiscountCodeByRef-price_ref">
				{ data._id }
			</div>

			<div className="c-dashboard__cell DiscountCodeByRef-used">
				{ formatNum(data.used_count, '0,0') }
			</div>

			<div className="c-dashboard__cell DiscountCodeByRef-available">
				{ formatNum(available, '0,0')}
			</div>

			<div className="c-dashboard__cell DiscountCodeByRef-details">

				<button type="button"
					onClick={ requestDetails }
					className={ bemit('c-table-btn', ['in-cell', 'icon']) }>
					<PiFolderOpenThin className="c-table-btn__icon" />
					<span className="c-table-btn__label">Détails</span>
				</button>

			</div>

		</div>
	);
}